import messages from "./messages";

export const LANGUAGE = [
  {name: messages.fr, id: "fr"},
  {name: messages.en, id: "en"}
];
